import React, { Component, createRef } from 'react';
import { FaCheck, FaPencilAlt, FaSortDown, FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import { connect } from 'react-redux';
import Switch from '../../components/UI/Switch/Switch';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import Modal from '../../components/UI/Modal/Modal';
import UserAvatar from '../../components/UI/react-user-avatar';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import AddDevicesToGroup from './AddDevicesToGroup/AddDevicesToGroup';
import SchedulePause from './DeviceGroupSchedulePause/DeviceGroupSchedulePause';
import classes from './GroupDeviceDetails.css';
import GroupDevices from './GroupDevices/GroupDevices';
import MoveDevicesToGroup from './MoveDevicesToGroup/MoveDevicesToGroup';

class GroupDetailPage extends Component {
  constructor(props) {
    super(props);
    this.saveGroupBtn = true;
    this.state = {
      showEditDeviceGroupName: false,
      action: '',
      result: null,
      showDropDownList: false,
      isInvalidGroupName: false,
      groupNameError: '',
      confirmModal: false,

      groupIcon: this.props.groupDetails.imageId
        ? this.props.groupDetails.imageId
        : undefined,
      showGroupIconSelect: false,
      showDeviceHandler: this.props.showMoveDevice
        ? this.props.showMoveDevice
        : 'edit',
      controls: {
        groupName: {
          elementType: 'input',
          elementConfig: {
            type: 'GroupName',
            placeholder: 'Group Name',
          },
          value: this.props.groupDetails.nickname,
          validation: {
            required: true,
            minLength: 6,
            maxLength: 30,
          },
          valid: false,
          touched: false,
        },
      },
      groupIconDetails: {
        deviceIconReference: this.props.groupDetails?.imageId
          ? this.props.groupDetails.imageId
          : undefined,
      },
      foreverEnabled: null,
      freezeIsLoaded: false,
      customEnabled: null,
      customTemp: null,
      untilMidnightEnabled: null,
      checked: this.props.groupDetails && this.props.groupDetails.freeze && this.props.groupDetails.freeze.frozen ? this.props.groupDetails.freeze.frozen : false,
      deviceGroupConfirmation: false,
      steeringDevices: false,
      conflictSchedule: false,
    };

    this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
    this.toggleEditGroupName = this.toggleEditGroupName.bind(this);
    this.submitGroupNameHandler = this.submitGroupNameHandler.bind(this);
    this.showGroupIconSelect = this.showGroupIconSelect.bind(this);
    this.showDropdown = this.showDropdown.bind(this);
    this.emojiHandler = this.emojiHandler.bind(this);
    this.defaultInitials = this.defaultInitials.bind(this);
    this.handleTogglePause = this.handleTogglePause.bind(this);
    this.onOpenModal = this.onOpenModal.bind(this);
    this.handleGroupSteering = this.handleGroupSteering.bind(this);
    this.closeScheduleSteeringMessageModal = this.closeScheduleSteeringMessageModal.bind(this);
    this.checkScheduleConflict = this.checkScheduleConflict.bind(this);

    this.dropDownRef = createRef();
  }
  toggleEditGroupName = (e) => {
    this.setState({
      showEditDeviceGroupName: !this.state.showEditDeviceGroupName,
    });

    
  };

  handleGroupNameChange = (e) => {
    let name = e.target.value;
    this.saveGroupBtn = false;
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        groupName: {
          ...prevState.controls.groupName,
          value: name,
        },
      },
    }));
    let res;
    const spaceError = 'Space is only allowed in between the characters.'; //The following characters are not allowed $ {"<"} > ` \ ^ & ; "
    // debugger;
    if (name.length === 0) {
      this.setState({ isInvalidGroupName: true, groupNameError: 'Empty name is not allowed' })
    } else if (name.trim() === '') {
      this.setState({ isInvalidGroupName: true, groupNameError: 'Empty name is not allowed' });
    } else if (!(/^[^<>]+$/.test(name.trim()))) {
      this.setState({ isInvalidGroupName: true, groupNameError: 'Special Characters are not allowed <>' })
    } else if (/^\s|\s{}|\s$/.test(name)) {
      this.setState({ isInvalidGroupName: true, groupNameError: spaceError })
    } else if (/\s{2,}/g.test(name)) {
      this.setState({ isInvalidGroupName: true, groupNameError: 'Space is only allowed in between the characters' })
    }  else if (this.isGroupNameExist(name)) {
      this.setState({ isInvalidGroupName: true, groupNameError: 'Group Name entered already exists' })
    } else if (name.length > 30) {
      this.setState({ isInvalidGroupName: true, groupNameError: '' })
    } else if (name.length == 30) {
      this.setState({ isInvalidGroupName: false, groupNameError: 'Max Character Limit Reached' })
    } else if (name.length === 0) {
      this.setState({ isInvalidGroupName: true, groupNameError: 'Empty name is not allowed' })
    } else if (name.trim() === '') {
      this.setState({ isInvalidGroupName: true });
    } else {
      this.setState({ isInvalidGroupName: false, groupNameError: '' })
    }
  };

  isGroupNameExist = (name) => {
    let groups = this.props.groups.filter((g) => g.nickname === name);
    //console.log("groups name", groups, groups.length > 0);
    return groups.length > 0;
  };

  showGroupIconSelect() {
    this.setState({
      showGroupIconSelect: true,
    });
  }

  isValidName(value) {
    if (/\s+$/.test(value) || /^\s/.test(value)) {
      return false;
    } else return true;
  }
  submitGroupNameHandler = (event) => {
    this.onOpenModal('', 'change your group name');
  };

  handleClickOutSide = (event) => {
    if (
      this.dropDownRef.current &&
      !this.dropDownRef.current.contains(event.target)
      && this.state.showDropDownList
    ) {
      this.setState({
        showDropDownList: false,
      });
    }
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutSide, true);
  }

  componentWillUnmount() {
   document.removeEventListener('click', this.handleClickOutSide, true);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const state = {};
    // console.log('Dervied State :::', nextProps, prevState)
    if (!prevState.freezeIsLoaded &&
      nextProps.groupDetails &&
      nextProps.groupDetails.freeze &&
      nextProps.groupDetails.freeze.timeTemplates &&
      nextProps.groupDetails.freeze.timeTemplates.length
    ) {
      let customTempHandle = nextProps.groupDetails.freeze.timeTemplates.find(
        (item, ind, arr) => {
          return item.id === 'custom';
        }
      );
      let untilMidnightTempHandle =
        nextProps.groupDetails.freeze.timeTemplates.find((item, ind, arr) => {
          return item.id === 'untilMidnight';
        });
      let foreverTempHandle = nextProps.groupDetails.freeze.timeTemplates.find(
        (item, ind, arr) => {
          return item.id === 'forever';
        }
      );

      const forev = foreverTempHandle;
      if (forev && (forev.enable === true || forev.enable === false)) {
        state.foreverEnabled = forev.enable;
      }
      const cust = customTempHandle;
      
      state.customTemp = cust;
      if (cust && (cust.enable === true || cust.enable === false)) {
        state.customEnabled = cust.enable;
      }
      const midni = untilMidnightTempHandle;
      if (midni && (midni.enable === true || midni.enable === false)) {
        state.untilMidnightEnabled = midni.enable;
      }

      state.freezeIsLoaded = true;
    }
    return state;
  }

  componentDidUpdate() {
    //  console.log(this.props, this.state, 'didupdate');
    if (
      !this.state.freezeIsLoaded &&
      this.props.groupDetails &&
      this.props.groupDetails.freeze &&
      this.props.groupDetails.freeze.timeTemplates &&
      this.props.groupDetails.freeze.timeTemplates.length
    ) {
      let customTempHandle = new Promise((res, rej) => {
        let cust = this.props.groupDetails.freeze.timeTemplates.find(
          (item, ind, arr) => {
            return item.id === 'custom';
          }
        );
        res(cust);
      });
      let untilMidnightTempHandle = new Promise((reso, reje) => {
        let midni = this.props.groupDetails.freeze.timeTemplates.find(
          (item, ind, arr) => {
            return item.id === 'untilMidnight';
          }
        );
        reso(midni);
      });
      let foreverTempHandle = new Promise((reso, reje) => {
        let forev = this.props.groupDetails.freeze.timeTemplates.find(
          (item, ind, arr) => {
            return item.id === 'forever';
          }
        );
        reso(forev);
      });

      let suspendTempHandle = this.props.groupDetails.freeze.suspended.enable;
      foreverTempHandle.then((forev) => {
        if (forev && (forev.enable === true || forev.enable === false)) {
          this.setState({
            foreverEnabled: forev.enable,
          });
        }
      });
      customTempHandle.then((cust) => {
        
        this.setState({
          customTemp: cust,
        });
        if (cust && (cust.enable === true || cust.enable === false)) {
          this.setState({
            customEnabled: cust.enable,
          });
        }
      });
      untilMidnightTempHandle.then((midni) => {
        if (midni && (midni.enable === true || midni.enable === false)) {
          this.setState({
            untilMidnightEnabled: midni.enable,
          });
        }
      });
      
      this.setState({
        freezeIsLoaded: true,
      });
    }
  }

  deviceGroupPauseHandler = (togglePause) => {
    let actions = [];
    const { freeze, id } = this.props.groupDetails;
    let isFrozen = freeze && freeze.frozen;
    let isCustom = this.state.customEnabled;
    let isForever = this.state.foreverEnabled;
    let isSuspended = freeze.suspended.enable;
    let isUntilMidnight = this.state.untilMidnightEnabled;
    if (togglePause === 'pause this group') {
      if (isCustom) {
        //console.log('custom is enabled');
        actions.push({ templateId: 'untilMidnight', action: 'PUT' });
      } else {
        actions.push({ templateId: 'forever', action: 'PUT' });
      }
    } else {
      if (isCustom) {
        //console.log('custom is enabled');
        actions.push({ templateId: 'suspend', action: 'PUT' });
      } else {
        actions.push({ templateId: 'freezes', action: 'DELETE' });

        //console.log('delete freezes API yet to be ready');
      }
    }
    // console.log('hitting pause device group with tempId & action',  actions);
    actions.forEach((action) => {
      if (action.templateId === 'freezes') {
        this.props.onFreezeDeviceGroup({ deviceGroupId: id });
      } else {
        this.props.onPauseDeviceGroup({
          deviceGroupId: id,
          templateId: action.templateId,
          action: action.action,
        });
      }
    });

    this.confirmModalCancelHandler('close');
  };

  handleTogglePause = (e) => {
    // const groupSteering = this.handleGroupSteering(this.props.groupDetails.devices);
    // if(!groupSteering){
    
      if (!this.state.checked) {
        const modalContent = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <h2 style={{ whiteSpace: 'nowrap' }}>Activate A Group Pause</h2>
            <p style={{ fontWeight: 'normal', textAlign: 'center' }}>
              This will pause all internet connectivity to the devices in this
              group
            </p>
            <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>
              Are you sure you want to proceed?
            </p>
          </div>
        );
        this.onOpenModal(modalContent, 'pause this group', 'showGroupDeviceFrom');
      } else {
        const modalContent = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <h2 style={{ whiteSpace: 'nowrap' }}>Activate A Group UnPause</h2>
            <p style={{ fontWeight: 'normal', textAlign: 'center' }}>
              This will Unpause all internet connectivity to the devices in this
              group
            </p>
            <p style={{ fontWeight: 'normal', margin: 0, textAlign: 'center' }}>
              Are you sure you want to proceed?
            </p>
          </div>
        );
        this.onOpenModal(
          modalContent,
          'unpause this group',
          'showGroupDeviceFrom'
        );
      }

    //   this.setState((state) => ({ checked: !state.checked }));
    // }
    
  };

  submitGroupIconHandler = (e) => {
    let grpIcon = e.target.value;
    this.setState({
      groupIcon: grpIcon,
    });
    this.onOpenModal('', 'change your group icon');
  };

  cancelGroupName = () => {
    let grpName = this.props.groupDetails.nickname;
    this.setState((prevState) => ({
      ...prevState,
      controls: {
        ...prevState.controls,
        groupName: {
          ...prevState.controls.name,
          value: grpName,
        },
      },
    }));
    this.setState({
      showEditDeviceGroupName: !this.state.showEditDeviceGroupName,
      isInvalidGroupName: false,
      groupNameError: '',
    });
  };

  onOpenModal = (result, action, showGroupDeviceFrom) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
      deviceGroupConfirmation: showGroupDeviceFrom ? true : false,
    });
  };

  confirmModalConfirmHandler = () => {
    if (this.state.action === 'change your group name') {
      let payload = {
        grpName: this.state.controls.groupName.value.trim(),
        grpIcon: this.props.groupDetails.imageId,
        grpId: this.props.groupDetails.id,
        type: 'editDeviceDetails',
      };
      this.props.changeDeviceGroupDetails(payload);
    }

    if (this.state.action === 'change your group icon') {
      let payload = {
        grpName: this.props.groupDetails.nickname.trim(),
        grpIcon: this.state.groupIcon,
        grpId: this.props.groupDetails.id,
        type: 'editDeviceDetails',
      };

      this.props.changeDeviceGroupDetails(payload);
    }
    if (
      this.state.action ===
      `delete this ${this.props.groupDetails.nickname} group`
    ) {
      this.props.deleteGroup(this.props.groupDetails.id);
    }
    if (
      this.state.action === 'pause this group' ||
      this.state.action === 'unpause this group'
    ) {
      // this.props.onChangePauseDevice(this.state.checked ? false : true, this.props.groupDetails.id);
      return this.deviceGroupPauseHandler(this.state.action);
    }
    this.confirmModalCancelHandler('close');
  };

  confirmModalCancelHandler = (e) => {
    this.setState((oldState) => ({
      confirmModal: false,
      showEditDeviceGroupName: false,
      checked: this.props.groupDetails &&
        this.props.groupDetails.freeze &&
        this.props.groupDetails.freeze.frozen
        ? true
        : false,
      deviceGroupConfirmation: false,
    }));
    if (e === 'close' && this.state.action ===  `delete this ${this.props.groupDetails.nickname} group`) {
      this.props.closeGroupDetailsPage();
    }
    if (this.state.action === 'change your group name') {
      this.cancelGroupName();
    }
    // console.log('props after update :::', this.state, this.props);
  };
  emojiHandler() {
    const emojiRegex = require('emoji-regex');
    const regex = emojiRegex();
    let match;
    while ((match = regex.exec(this.state.controls.groupName.value))) {
      const emoji = match[0];
      return emoji;
    }
  }

  showDropdown() {
    if (!this.state.showDropDownList) {
      this.setState({
        showDropDownList: true,
      });
    } else {
      this.setState({
        showDropDownList: false,
      });
    }
  }

  defaultInitials(name) {
    var maxInitials = 2;
    return name
      .split(/\s/)
      .map(function (part) {
        return part.substring(0, 1).toUpperCase();
      })
      .filter(function (v) {
        return !!v;
      })
      .slice(0, maxInitials)
      .join('')
      .toUpperCase();
  }

  checkScheduleConflict (scheduleInfo, devices){
    // console.log('Custom temp :::', scheduleInfo);
    const templateCopy = Object.assign({}, scheduleInfo);
    
    if (templateCopy.customSchedules && templateCopy.customSchedules.length) {
      // console.log('templateCopy :::', templateCopy);
      const schedule = Object.assign({}, templateCopy.customSchedules);     
      let day = new Date().getDay() === 0 ? 7 : new Date().getDay(); // Considering sunday as 7
     
      
      
      if(schedule[0].daysOfWeek.includes(day) || (schedule[1] && !schedule[0].daysOfWeek.includes(day))){
        const time = new Date().getHours() + ':' + new Date().getMinutes();
        // console.log('difference ----',  schedule[0].startTime,  new Date().getTime());
        let currentTime = time.split(':')
        // console.log('');
        let currentHour = parseInt(currentTime[0]);
        let currentMinute = currentTime[1];

        const scheduleTime = schedule[0].startTime.split(':')
        let scheduleHour = parseInt(scheduleTime[0]) === 0 ? 24 : parseInt(scheduleTime[0]);
        let scheduleMinute = scheduleTime[1];
        
        //  console.log('Time :::',currentHour,' -- ', scheduleHour, 'Minutes :::', currentMinute, '----', scheduleMinute);
        if (currentHour == scheduleHour) {
          return true;
        } else {
          if(scheduleHour > currentHour){
           if(scheduleHour - currentHour > 1){
             if(scheduleHour == 24){
              const scheduleEndTime = schedule[0].endTime.split(':')
              const scheduleEndHour = parseInt(scheduleEndTime[0]);
             // let scheduleEndMinute = scheduleEndTime[1];
                // console.log('scheduleEndHour :::', scheduleEndHour);
                if(scheduleEndHour > currentHour){
                  return true;
                }else{
                  return false;
                }
             }else{
              //  console.log('schedule ::::', schedule, Object.keys(schedule).length );
               if(Object.keys(schedule).length > 1){
                const scheduleEndTime = schedule[1].endTime.split(':')
                const scheduleEndHour = parseInt(scheduleEndTime[0]); 
                // console.log('scheduleEndHour :::', currentHour , scheduleEndHour);
                if(scheduleEndHour > currentHour){
                  return true;
                }               
               }              
              return false;
             }
             
           } else if(scheduleHour - currentHour == 1){
            const devicesWithRemainingTime = devices.map((device)=>{
              if (device.steering && device.steering.forced && device.steering.forced.expiresAt) {
                const remainingSterringTime = device.steering && device.steering.forced && device.steering.forced.expiresAt;
                const steeringExpiresHour = new Date(remainingSterringTime).getHours(); // Time at the End of steering (in seconds)
                const steeringExpiresMinute = new Date(remainingSterringTime).getMinutes(); // Time at the End of steering (in seconds)
              //   console.log('steeringExpiresHour :::', steeringExpiresHour, 'scheduleHour ::', scheduleHour);
              //  console.log('steeringExpiresMinute :::', steeringExpiresMinute, 'scheduleMinute :', scheduleMinute);
                if (scheduleHour > steeringExpiresHour  || (scheduleHour === steeringExpiresHour && scheduleMinute > steeringExpiresMinute)){
                  return false;
                } else {
                  
                  return true;
                }
              }
              
            })
            // console.log('devicesWithRemainingTime ::', devicesWithRemainingTime); 
            if(devicesWithRemainingTime.includes(true)){
              return true;
            }
            return false;
           }
          } else if(currentHour > scheduleHour){
            if(currentHour - scheduleHour > 1 && schedule[0].endTime != 'null' && schedule[0].endTime != null  ){
              const scheduleEndTime = schedule[0].endTime.split(':')
              const scheduleEndHour = parseInt(scheduleEndTime[0]);
             // let scheduleEndMinute = scheduleEndTime[1];
                // console.log('scheduleEndHour :::', scheduleEndHour);
                if(scheduleEndHour > currentHour){
                  return true;
                }else{
                  return false;
                }
           //   return false;  
            } else if(currentHour - scheduleHour == 1){
              const devicesWithRemainingTime = devices.map((device)=>{
                if (device.steering && device.steering.forced && device.steering.forced.expiresAt) {
                  const remainingSterringTime = device.steering && device.steering.forced && device.steering.forced.expiresAt;
                  const steeringExpiresHour = new Date(remainingSterringTime).getHours() == 0 ? 24 : new Date(remainingSterringTime).getHours(); // Time at the End of steering (in seconds)
                  const steeringExpiresMinute = new Date(remainingSterringTime).getMinutes(); // Time at the End of steering (in seconds)
                  // console.log('steeringExpiresHour :::', steeringExpiresHour, 'scheduleHour ::', scheduleHour);
                  // console.log('steeringExpiresMinute :::', steeringExpiresMinute, 'scheduleMinute :', scheduleMinute);
                  if (scheduleHour > steeringExpiresHour  || (scheduleHour === steeringExpiresHour && scheduleMinute > steeringExpiresMinute)){
                    return false;
                  } else {
                    
                    return true;
                  }
                }
                
              })
              // console.log('devicesWithRemainingTime ::', devicesWithRemainingTime); 
              if(devicesWithRemainingTime.includes(true)){
                return true;
              }
              return false;
            }else{
              return true;
            }
          }             
        }
      }          
    }
  
  }

  checkForLiveSchedule = (scheduleInfo, type='') => {
    const schedule = Object.assign({}, scheduleInfo);
    const time = new Date().getHours() + ':' + new Date().getMinutes();
    let currentTime = time.split(':')
    let currentHour = parseInt(currentTime[0]);    
    let day = new Date().getDay() === 0 ? 7 : new Date().getDay(); // Considering sunday as 7
   
    if(type === 'EDIT_SCHEDULE'){
      // console.log('coming :::', schedule);
      if(!schedule[0].daysOfWeek.includes(day) && schedule[1] && !schedule[1].daysOfWeek.includes(day)){
        
        return false;
      }else if(Object.keys(schedule).length == 1 && !schedule[0].daysOfWeek.includes(day)){
        return false;
      }
    }
    
    if(schedule[0].daysOfWeek.includes(day)){

      const scheduleTime = schedule[0].startTime.split(':')
      let scheduleStartHour = parseInt(scheduleTime[0]) === 0 ? 24 : parseInt(scheduleTime[0]);
      // console.log('Checking for live schedule :::', currentHour, scheduleStartHour);
      if(scheduleStartHour - currentHour == 1){
        return true;
      }else if(scheduleStartHour == currentHour){
        if(Object.keys(schedule).length > 1 && schedule[0].daysOfWeek.includes(day) && schedule[1].daysOfWeek.includes(day)){
          const scheduleEndTime = schedule[1].endTime.split(':')
          const scheduleEndHour = parseInt(scheduleEndTime[0]); 
          // console.log('scheduleEndHour :::', currentHour , scheduleEndHour);
          if(scheduleEndHour > currentHour){
            return true;
          }else{
            return false;
          }               
        }              
        return true;
      }else{
        if(currentHour > scheduleStartHour){
        const scheduleEndTime = schedule[0].endTime.split(':')
        const scheduleEndHour = parseInt(scheduleEndTime[0]); 
        // console.log('scheduleEndHour :::', currentHour , scheduleEndHour);
        if(scheduleEndHour > currentHour){
          return true;
        }               
      }
      return false; 
      }
    }else if(schedule[1] && !schedule[0].daysOfWeek.includes(day)){
      // console.log('coming into it');
      if(Object.keys(schedule).length > 1){
        const scheduleEndTime = schedule[1].endTime.split(':')
        const scheduleEndHour = parseInt(scheduleEndTime[0]); 
        // console.log('scheduleEndHour :::', currentHour , scheduleEndHour);
        if(scheduleEndHour > currentHour){
          return true;
        }               
      }              
      return false;
    }
  }

  handleGroupSteering = (devices,type='', grpDetails = '', grpSteeringDevices='') => {
    // console.log(' devices ::::', devices, grpDetails);
    // console.log('grpSteeringDevices :::', grpSteeringDevices);
    // Checking for group steering devices in the first place
    if(type === 'EDIT_SCHEDULE' && grpSteeringDevices?.length > 0){
      this.setState({ 
        steeringDevices : true
       });
       return true;
    }
     

    // Checking any device with freqBand 2.4G 
    let scheduleConflict = false;
    let schedulePause;
    let groupPause = this.props.groupDetails && this.props.groupDetails.freeze && this.props.groupDetails.freeze.frozen ? this.props.groupDetails.freeze.frozen : false
    
    if(type === 'ADD_DEVICE' || type === 'MOVE_DEVICE' || type === 'EDIT_SCHEDULE'){
      let scheduleInfo = this.state.customTemp;
      if(type === 'MOVE_DEVICE'){
        scheduleInfo = grpDetails.freeze.timeTemplates.find(
          (item, ind, arr) => {
            return item.id === 'custom';
          }
        );        
      }else if(type === 'EDIT_SCHEDULE'){
        scheduleInfo = grpDetails; // grpDetails is the new schedule object passed from GroupPauseScheduleForm.js
        scheduleConflict = this.checkForLiveSchedule(scheduleInfo.customSchedules, 'EDIT_SCHEDULE');
        groupPause = scheduleConflict ? true : false;
      }

        // console.log('Scheule Info:::', scheduleInfo)
       // Checking group Pause
     if(type === 'MOVE_DEVICE'){
      groupPause = grpDetails.freeze.frozen;
 
     }
     
    //  console.log('groupPause:::::',groupPause)
      if(groupPause){
        scheduleConflict =  true;
      } else {
        // console.log('groupPause :::', groupPause, scheduleInfo);
        // if(!groupPause && scheduleInfo && scheduleInfo.enable){
        //   scheduleConflict =  false;
        // }else 
        if(scheduleInfo && scheduleInfo.enable && type !== 'EDIT_SCHEDULE'){
          scheduleConflict = this.checkScheduleConflict(scheduleInfo, devices);
          // console.log('groupPause :::', groupPause, scheduleInfo,scheduleConflict);
          if(!groupPause && scheduleInfo && scheduleInfo.enable && scheduleConflict ){
            scheduleConflict = this.checkForLiveSchedule(scheduleInfo.customSchedules);
          }
        }
        
      } 
    }
      // console.log('schedul conflict ::::', scheduleConflict,type); 
     let steeringDevices = 
     devices ? devices.map((device)=>{
       
         if (device.steering && device.steering.forced && device.steering.forced.freqBand && typeof device.steering.forced.freqBand === 'string') {
           const freq = device.steering && device.steering.forced && device.steering.forced.freqBand && device.steering.forced.freqBand.includes('2.4G');
           return freq
         }
           // return device.freqBand?.includes('5G') ;
         
       }) 
       : '';
    
    //  console.log('steeringDevices ::', steeringDevices, scheduleConflict)
       
     if(steeringDevices.includes(true)){
       if(type == ''){
        this.setState({ 
          steeringDevices : true
         });
         return true;
       }else{
         this.setState({
           steeringDevices : scheduleConflict ? true : false,
           conflictSchedule : scheduleConflict ? true : false
         })
         return scheduleConflict ? true : false
        }      
     }else if(type === 'EDIT_SCHEDULE' && scheduleConflict && steeringDevices.includes(true)){
      this.setState({ 
        steeringDevices : true
       });
       return true;
     }
     return false;
  }
 
   closeScheduleSteeringMessageModal(){
     this.setState({
       steeringDevices : false
     })
   }
 
 

  render() {
    // console.log('group device dteails props ::::', this.props);
    const { closeGroupDetailsPage, groupDetails } = this.props;

    let grpIconValue;
    if (this.state.groupIcon) {
      grpIconValue = this.state.groupIcon;
    } else {
      grpIconValue = this.props.groupDetails.imageId;
    }
    grpIconValue = this.emojiHandler();
    if (
      (grpIconValue === undefined ||
      grpIconValue === null ||
      grpIconValue === '') &&
      this.state.controls && this.state.controls.groupName && this.state.controls.groupName.value
    ) {
      grpIconValue = this.state.controls.groupName.value;
      if (/\s/.test(grpIconValue.trim())) {
        grpIconValue = this.defaultInitials(grpIconValue);
      } else {
        grpIconValue = grpIconValue.charAt(0).toUpperCase();
      }
    }
    let grpIconSelect;
    if (grpIconValue !== undefined && grpIconValue.length > 0) {
      grpIconSelect = (
        <div>
          <UserAvatar
            size="50"
            color="#06455a"
            style={{ color: '#fff' }}
            round={true}
            name={grpIconValue}
          />
        </div>
      );
    }

    let deviceNameHtml;
    if (this.state.showEditDeviceGroupName) {
      // console.log('Name chnage :', this.state.isInvalidGroupName);

      deviceNameHtml = (
        <Box>
          <div
            className={[
              this.state.showEditDeviceGroupName
                ? ''
                : classes.HideEditDeviceGroupName,
            ].join('')}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                <input
                  id="GroupNameEditTxt"
                  type="text"
                  style={{ width: '155px', borderColor: this.state.controls.groupName.value.length ? (this.state.isInvalidGroupName || this.state.groupNameError != '') ? 'red' : '#86A8DF' : '' }}
                  name="groupName"
                  minLength="3"
                  required
                  maxLength="30"
                  value={this.state.controls.groupName.value}
                  onChange={this.handleGroupNameChange}
                  aria-label={"Group name edit"}
                  
                />
                <div  id='EditGroupNameErr' style={this.state.isInvalidGroupName ? { color: 'red', fontSize: 12 } : { display: 'none' }} > {this.state.groupNameError}</div>
                <div id='EditGroupNameMaxErr' style={(!this.state.isInvalidGroupName && this.state.groupNameError) ? { color: 'red', fontSize: 12 } : { display: 'none' }} > {this.state.groupNameError}</div>
                {(!this.state.isInvalidGroupName || (this.state.controls.groupName.value.length > 30 && !this.state.groupNameError.length)) && <div className={classes.groupNameLength}>
                  <span style={this.state.controls.groupName.value.length > 30 ? { color: 'red' } : {}}>{this.state.controls.groupName.value.length}</span>/30
                </div>}
              </div>
              <button
                id="saveGroupName"
                disabled={this.state.isInvalidGroupName || this.state.controls.groupName.value === this.props.groupDetails.nickname}
                className={classes.saveGroupNameBtn}
                title="Change Group Name"
                onClick={this.submitGroupNameHandler}
                // disabled={this.state.controls.groupName.value === this.props.groupDetails.nickname}
              >
                <FaCheck color={this.state.isInvalidGroupName || this.state.controls.groupName.value === this.props.groupDetails.nickname ? 'gray' : 'green'} />
              </button>
              <button
                className={classes.cancelGroupNameBtn}
                onClick={this.cancelGroupName}
                id="cancelGroupName"
                title="Cancel Group Name"><FaTimes color={'red'}
                />
              </button>
                </div>
             
             
            </div>
        </Box>
      );
    } else {
      deviceNameHtml = (
        <Box>
          {/* <div className={!this.state.showEditDeviceGroupName?'':classes.HideEditDeviceGroupName}> */}
          <h3 id="GroupName" className={classes.GroupName}>
            {groupDetails && groupDetails.nickname}
          </h3>
          <button
            id="GroupNameEditButton"
            className={classes.GroupNameEditButton}
            onClick={this.toggleEditGroupName}
          >
            <FaPencilAlt color={'gray'} />
          </button>
        </Box>
      );
    }

    let groupDevicesHtml,
      addDevicesHtml,
      moveDevicesHtml,
      visibleDeviceContent,
      addStyling,
      moveStyling,
      removeStyling;
    if (this.state.showDeviceHandler === 'add') {
      groupDevicesHtml = (
        <GroupDevices
          devices={groupDetails ? groupDetails.devices || [] : []}
          currentGroup={groupDetails && groupDetails.nickname}
        />
      );

      addDevicesHtml = (
        <AddDevicesToGroup
          devices={this.props.devicesByEquipment}
          deviceGroups={this.props.groups}
          groupDetails={groupDetails}
           handleGroupSteering={this.handleGroupSteering}
          // steeringDevices={this.state.steeringDevices}
          //closeGroupDetailsPage={this.props.closeGroupDetailsPage}
          isGroupSuspend={groupDetails.freeze.suspended.enable}
        />
      );
      visibleDeviceContent = 'Add Device';
      addStyling = { backgroundColor: '#0073d1', color: '#fff' };
    } else if (this.state.showDeviceHandler === 'move') {
      groupDevicesHtml = <div />;
      addDevicesHtml = <div />;

      moveDevicesHtml = (
        <MoveDevicesToGroup
          devices={this.props.devicesByEquipment}
          deviceGroups={this.props.groups}
          groupDetails={groupDetails}
        //  closeGroupDetailsPage={this.props.closeGroupDetailsPage}
          selectedDeviceMac={this.props.selectedDeviceMac}
          handleGroupSteering={this.handleGroupSteering}
        />
      );
      visibleDeviceContent = 'Move Device';
      moveStyling = { backgroundColor: '#0073d1' };
    } else if (this.state.showDeviceHandler === 'remove') {
      groupDevicesHtml = (
        <GroupDevices
          devices={groupDetails ? groupDetails.devices || [] : []}
          currentGroup={groupDetails && groupDetails.nickname}
          groupDetails={groupDetails}
         // closeGroupDetailsPage={this.props.closeGroupDetailsPage}
          showDeviceHandler={this.state.showDeviceHandler}
          
        />
      );
      moveDevicesHtml = null;
      addDevicesHtml = null;
      visibleDeviceContent = 'Remove Device';
      removeStyling = { backgroundColor: '#0073d1' };
    } else {
      groupDevicesHtml = (
        <GroupDevices
          devices={groupDetails ? groupDetails.devices || [] : []}
          currentGroup={groupDetails && groupDetails.nickname}
        />
      );
      moveDevicesHtml = null;
      addDevicesHtml = null;
      visibleDeviceContent = 'Edit Group';
    }
    let deviceOptionsHtml;
    let groupPauseToggle = (
      <div className={classes.leftDetails}>
        <h4
          style={{
            color: `${groupDetails &&
              groupDetails.devices &&
              groupDetails.devices.length
              ? ''
              : 'lightgrey'
              }`,
          }}
        >
          Group Pause
        </h4>
        <div>
          <Switch
            id="GroupSchedulePauseToggle"
            onColor="#0073d1"
            disabled={!(groupDetails && groupDetails.devices && groupDetails.devices.length)}
            onChange={this.handleTogglePause}
            checked={!!this.state.checked}
          />
        </div>
      </div>
    );

    deviceOptionsHtml = (
      <div className={classes.GroupDetailsEdit}>
        <div ref={this.dropDownRef}>
          <button
            id="DeleteGroup"
            className={classes.RegularButton}
            onClick={() => {
              this.onOpenModal(
                '',
                `delete this ${groupDetails.nickname} group`
              );
            }}
          >
            Delete Group
          </button>
          <span style={{ padding: '10px', color: 'lightgray' }}>|</span>
          <span onClick={this.showDropdown}>
            <span id="EditGroup" className={classes.RegularButton}>
              {visibleDeviceContent}
            </span>
            <FaSortDown color={'#0073d1'} />{' '}
          </span>
          <div className={classes.Dropdown}>
            <div
              id="myDropdown"
              className={classes.DropdownContent}
              style={{
                display: this.state.showDropDownList ? 'block' : 'none',
              }}
            >
              <a
                onClick={() => {
                  this.setState({
                    showDeviceHandler: 'add',
                    showDropDownList: false,
                  });
                }}
                style={{
                  borderBottom: '1px solid lightgray',
                  marginRight: '5px',
                  marginLeft: '5px',
                  textIndent: '5px',
                  cursor: 'pointer',
                }}
              >
                Add Device
              </a>
              <a
                onClick={() => {
                  if (
                    groupDetails &&
                    groupDetails.devices &&
                    groupDetails.devices.length
                  ) {
                    this.setState({
                      showDeviceHandler: 'remove',
                      showDropDownList: false,
                    });
                  }
                }}
                style={{
                  color: `${groupDetails &&
                    groupDetails.devices &&
                    groupDetails.devices.length
                    ? ''
                    : 'lightgrey'
                    }`,
                  pointerEvents: `${groupDetails &&
                    groupDetails.devices &&
                    groupDetails.devices.length
                    ? ''
                    : 'none'
                    }`,
                  borderBottom: '1px solid lightgray',
                  marginRight: '5px',
                  marginLeft: '5px',
                  textIndent: '5px',
                  cursor: 'pointer',
                }}
              >
                Remove Device
              </a>
              <a
                onClick={() => {
                  if (
                    groupDetails &&
                    groupDetails.devices &&
                    groupDetails.devices.length
                  ) {
                    this.setState({
                      showDeviceHandler: 'move',
                      showDropDownList: false,
                    });
                  }
                }}
                style={{
                  color: `${groupDetails &&
                    groupDetails.devices &&
                    groupDetails.devices.length
                    ? ''
                    : 'lightgrey'
                    }`,
                  pointerEvents: `${groupDetails &&
                    groupDetails.devices &&
                    groupDetails.devices.length
                    ? ''
                    : 'none'
                    }`,
                  borderBottom: '1px solid lightgray',
                  marginRight: '5px',
                  marginLeft: '5px',
                  textIndent: '5px',
                  cursor: 'pointer',
                }}
              >
                Move Device
              </a>
            </div>
          </div>
        </div>
        {groupPauseToggle}
      </div>
    );
    // }

    let groupSteeringDevices = 
    groupDetails.devices ? groupDetails.devices.filter((device)=>{
      
        if (device?.steering?.forced?.freqBand && typeof device.steering.forced.freqBand === 'string') {
          const freq = device?.steering?.forced?.freqBand && device.steering.forced.freqBand.includes('2.4G');
          return freq
        }        
      }): ''; 
    
    let schedulePauseHtml=(<div />);
    // console.log('schedule props ::', this.props, this.state);
    if (
      (!this.props.groupLoading ||
      this.props.groupLoaded) && !this.props.pauseDeviceGroupSuccess
    ) {           
      schedulePauseHtml = (
        <SchedulePause
          groupDetails={this.props.groupDetails}
          modalCancel={this.confirmModalCancelHandler}
          freeze={
            this.props.groupDetails.freeze
              ? this.props.groupDetails.freeze
              : undefined
          }
          customTemp={this.state.customTemp}
          handleGroupSteering={this.handleGroupSteering}
          steeringDevices={this.state.steeringDevices}
        //  closeGroupDetailsPage={this.props.closeGroupDetailsPage}
        isDeviceSuspend={this.props.groupDetails.freeze.suspended.enable}
        groupSteeringDevices = {groupSteeringDevices}
        />
      );
    }
    // const steeringDeviceWarning = 'The selected smartphone/tablet has been steered and must not be paused or scheduled to begin a scheduled pause in the next 60 minutes.';
    // 'The selected smartphone/tablet is paused or will begin a scheduled pause in the next 60 minutes and must be un-paused or the pause schedule modified to be used for 2.4GHz.'
  

    return (
      <Box>
        <div className={classes.GroupDetailPage}>
          <div>
            <h3
              id="backToExistingGroups"
              className={classes.RegularButton}
              onClick={() => {
                closeGroupDetailsPage();
              }}
            >
              {'< '} Back To Existing Groups
            </h3>
          </div>
          <div className={classes.Separator} />
          <div className={classes.GroupDetailName}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginRight: '20px',
              }}
            >
              {grpIconSelect}
            </div>
            {deviceNameHtml}
          </div>

          {deviceOptionsHtml}
          {groupDevicesHtml}
          {addDevicesHtml}
          {moveDevicesHtml}
          {schedulePauseHtml}
        </div>
        <Modal
          deviceGroupConfirmation={
            this.state.deviceGroupConfirmation ? 'true' : 'false'
          }
          show={this.state.confirmModal}
          modalClosed={this.confirmModalCancelHandler}
        >
          <Confirm
            id={'DeleteGroupConfirm'}
            deviceGroupConfirmation
            action={this.state.result ? '' :`Are you sure you want to ${this.state.action}?`}
            result={this.state.result}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Yes"
          />
        </Modal>
        {/* {this.state.steeringDevices && (
          <Modal
          id="DSAlertMsgGroupDetailsPage"
          deviceGroupConfirmation="true"
          show={this.state.steeringDevices}
         modalClosed={this.closeScheduleSteeringMessageModal}
        >
         <div>
           <div style={{ display:'flex', flexDirection:'column', padding: '25px 5px 5px 5px' }}>
           <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
           <FaExclamationTriangle
              id = 'DSAlertIcon'
              color={'red'}
              fontSize={'35px'}
              style={{ marginRight: '5px', marginTop: '8px' }} />
                    <h2>Error</h2>
                </div>
             
              <p id = 'DSGroupsModalWarning' style={{ fontWeight: 'normal' }}>
                {steeringDeviceWarning}
              </p>
            </div>
            <button className={classes.SteeringRegularButton} onClick={this.closeScheduleSteeringMessageModal}>
              OK
            </button>
          </div>                              
        </Modal>
        )} */}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedEquipment: state.equipment.selectedEquipment,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeDeviceGroupDetails: (payload) =>
      dispatch(actions.changeDeviceGroupDetails(payload)),
    deleteGroup: (deviceGroupId) =>
      dispatch(actions.deleteGroup(deviceGroupId)),
    onPauseDeviceGroup: (data) => dispatch(actions.pauseDeviceGroup(data)),
    onFreezeDeviceGroup: (data) => dispatch(actions.freezeDeviceGroup(data)),
  };
};

GroupDetailPage.defaultProps = {
  groupDetails: {
    devices: [],
  },
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(GroupDetailPage, api));
